/**
 * Manual TOTP key formatting (A.4, FR-011; sheet 07b callout 4).
 *
 * The API returns the pending secret as a bare base32 string. Authenticator
 * apps accept it with or without spaces, but a person copying it by hand reads
 * it in groups of four — the convention every major app prints. Uppercase
 * because base32 is case-insensitive and the apps show it that way. Rendered
 * in `--font-mono` (CLAUDE.md §5).
 */
export function formatManualKey(secret: string): string {
  const clean = secret.replace(/\s+/g, '').toUpperCase()
  return clean.match(/.{1,4}/g)?.join(' ') ?? ''
}
